/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerEntitySource;

(function (BrokerEntitySource) {
  BrokerEntitySource["CMS"] = "cms";
  BrokerEntitySource["BROKER_API"] = "broker_api";
})(BrokerEntitySource || (BrokerEntitySource = {}));